/**
 * Release Deployment API
 *
 * API endpoints for release deployment automation.
 */
import type {
  ReleaseDeploymentRequest,
  ReleaseDeploymentResponse,
} from '@/types/service/releaseDeployment';

import { baseProtectedApi } from '@/store/baseApi';

export const releaseDeploymentApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    executeReleaseDeployment: builder.mutation<ReleaseDeploymentResponse, ReleaseDeploymentRequest>(
      {
        query: (data) => ({
          url: '/v1/protected/release-deployment/execute',
          method: 'POST',
          data: {
            is_production: data.isProduction,
            dry_run: data.dryRun,
          },
        }),
      },
    ),
  }),
});

export const { useExecuteReleaseDeploymentMutation } = releaseDeploymentApi;
